import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-079708}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Michael_Tauchmann_Software_Engineering}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{LabDatabase}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{LabDatabase}_need_to_be_licensed___{LabDatabase}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_May_2026}____[v3]_[01]_MTc3ODc5OTYwMDAwMA==fad8b14cce2c718f88b14936b4058dd8'
);

registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXdcd3RWR2VZUUVyXUI=');
